"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ConnectedWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = require("styled-components");
var _styles = require("@material-ui/styles");
var _reactI18next = require("react-i18next");
var _jss = require("jss");
var _appSagas = _interopRequireDefault(require("./store/appSagas"));
var _appReducer = _interopRequireDefault(require("./store/appReducer"));
var _App = _interopRequireDefault(require("./components/App"));
var _PropsContext = require("./context/PropsContext");
var _services = require("./services");
var _i18n = _interopRequireDefault(require("./i18n"));
var _globals = _interopRequireDefault(require("./components/vfuk/globals"));
var _themes = _interopRequireDefault(require("./components/vfuk/themes"));
var _constants = require("./utils/constants");
var _useGuidedSellingStatus = require("./hooks/app/useGuidedSellingStatus");
var _useAppDispatch = require("./hooks/useAppDispatch");
var _useWindowAPI = _interopRequireDefault(require("./hooks/app/useWindowAPI"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const WidgetContent = _ref => {
  let {
    themeWS10,
    __instanceId,
    __pageId
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: themeWS10
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.I18nextProvider, {
    i18n: _i18n.default
  }, /*#__PURE__*/_react.default.createElement(themeWS10.globalStyles, null), /*#__PURE__*/_react.default.createElement(_App.default, {
    instanceId: __instanceId,
    pageId: __pageId
  })));
};
const Widget = props => {
  const {
    __instanceId,
    __pageId
  } = props;
  return /*#__PURE__*/_react.default.createElement(_PropsContext.PropsProvider, {
    widgetProps: {
      __instanceId,
      __pageId
    }
  }, /*#__PURE__*/_react.default.createElement(WidgetWithPropsContext, props));
};
const WidgetWithPropsContext = props => {
  var _config$uiSettings;
  const {
    config,
    i18n,
    language,
    __instanceId,
    __pageId,
    marketingId,
    addToCartCallback
  } = props;
  const {
    openGuidedSellingModal,
    closeGuidedSellingModal
  } = (0, _useGuidedSellingStatus.useGuidedSellingStatus)();
  const {
    setFlags,
    setMetadata,
    setSkippedQuestionIds
  } = (0, _useWindowAPI.default)();
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  if (!language || !config) {
    return null;
  }

  // setup language
  if (config.language && config.language !== language) {
    dispatch({
      type: 'LANGUAGE_REQUEST',
      payload: config.language
    });
    return null;
  }

  // setup services
  (0, _services.setupServices)({
    config,
    i18n,
    marketingId,
    addToCartCallback,
    closeGuidedSellingModal,
    openGuidedSellingModal,
    setFlags,
    setMetadata,
    setSkippedQuestionIds
  });

  // ---- Delete slider dots styles ----
  if (config && config.settings && config.settings.removeSliderDotStyles) {
    const styleTags = document.getElementsByTagName('style');
    for (let index = 0; index < styleTags.length; index++) {
      if (styleTags[index].textContent.match(/(?=(\.slick-dots\n{\n.*position:\sabsolute;\n\s*bottom:\s-25px;\n))/gm)) {
        console.log('Removing slick dot styles');
        styleTags[index].remove();
      }
    }
  }
  // ----

  // ---- Create the widget in shadow fom ----
  let styleSlot;
  if (config.enableShadowDOM) {
    const shadowAppRoot = document.getElementById(_constants.APP_ROOT_ID).shadowRoot;
    styleSlot = shadowAppRoot.getElementById(_constants.APP_SHADOW_DOM_STYLES_SLOT_ID);
    // Move generated styles from head to shadow root (this for sliders)
    const headStylesLinks = document.head.querySelector('[data-meta="gs-app"]');
    if (headStylesLinks) {
      const remoteStyles = document.createElement('style');
      remoteStyles.setAttribute('type', 'text/css');
      remoteStyles.setAttribute('data-meta', 'remote-styles');
      const importUrl = headStylesLinks.getAttribute('href');
      remoteStyles.innerHTML = `@import "${importUrl}";`;
      styleSlot.append(remoteStyles);
    } else {
      const headStyles = document.head.querySelectorAll('style');
      const stylesLink = document.head.querySelector('[href^="/guidedSelling.css"]');
      if (stylesLink) styleSlot.append(stylesLink);
      headStyles.forEach(style => {
        style.setAttribute('data-meta', 'head-styles');
        styleSlot.append(style);
      });
    }
  }

  // setup assets
  const assetsPath = 'assets/ws10/';
  const ingressUrl = window.REACT_APP_GS_INGRESS_URL;
  const assetsLocation = ingressUrl ? `https://${ingressUrl}/${assetsPath}` : assetsPath;

  // overwrite theme colors
  const overwrittenThemeName = (_config$uiSettings = config.uiSettings) === null || _config$uiSettings === void 0 ? void 0 : _config$uiSettings.theme;
  if (overwrittenThemeName) {
    const overwrittenTheme = (0, _themes.default)(overwrittenThemeName);
    if (overwrittenTheme) {
      const {
        primaryColor,
        ...themeAppearance
      } = overwrittenTheme;
      _r10SourceLibrary.themeWS10.color = {
        ..._r10SourceLibrary.themeWS10.color,
        primary1: {
          ..._r10SourceLibrary.themeWS10.color.primary1,
          default: primaryColor
        },
        secondary1: {
          ..._r10SourceLibrary.themeWS10.color.secondary1,
          default: primaryColor
        },
        focus: {
          ..._r10SourceLibrary.themeWS10.color.focus,
          default: primaryColor
        }
      };
      if (themeAppearance) _r10SourceLibrary.themeWS10.localThemes = themeAppearance;
      // apply icons theme colors
      const systemIconsRules = _r10SourceLibrary.themeWS10.getIconProperties('system');
      _r10SourceLibrary.themeWS10.setIconGroup('system', 'SourceSystemIcons', () => {
        return {
          ...systemIconsRules,
          appearance: {
            ...systemIconsRules.appearance,
            primary: {
              color: primaryColor
            }
          }
        };
      });
      if (themeAppearance.fontFamily) _r10SourceLibrary.themeWS10.baseFont.fontFamily = themeAppearance.fontFamily;
    }
  }
  _r10SourceLibrary.themeWS10.globalStyles = _globals.default;
  _r10SourceLibrary.themeWS10.setBaseAssetLocation(assetsLocation);
  _r10SourceLibrary.themeWS10.setAssetLocations('fonts', 'fonts/');
  _r10SourceLibrary.themeWS10.setAssetLocations('icons', 'icons/');
  _r10SourceLibrary.themeWS10.setAssetLocations('logos', 'logos/');
  if (!styleSlot) {
    return /*#__PURE__*/_react.default.createElement(WidgetContent, {
      themeWS10: _r10SourceLibrary.themeWS10,
      __instanceId: __instanceId,
      __pageId: __pageId
    });
  }

  // inject MUI styles
  const jss = (0, _jss.create)({
    ...(0, _styles.jssPreset)(),
    insertionPoint: styleSlot
  });
  return /*#__PURE__*/_react.default.createElement(_styledComponents.StyleSheetManager, {
    target: styleSlot
  }, /*#__PURE__*/_react.default.createElement(_styles.StylesProvider, {
    jss: jss
  }, /*#__PURE__*/_react.default.createElement(WidgetContent, {
    themeWS10: _r10SourceLibrary.themeWS10,
    __instanceId: __instanceId,
    __pageId: __pageId
  })));
};
const mapStateToProps = state => ({
  language: state.language.language
});
const ConnectedWidget = (0, _reactRedux.connect)(mapStateToProps)(Widget);
exports.ConnectedWidget = ConnectedWidget;
const exported = ConnectedWidget;
var _default = exported;
exports.default = _default;
Widget.propTypes = {
  i18n: _propTypes.default.any,
  language: _propTypes.default.string,
  __instanceId: _propTypes.default.string,
  __pageId: _propTypes.default.string
};
exported.reducer = _appReducer.default;
exported.sagas = _appSagas.default;

// exported.middlewares = [logger];